import angular from 'angular';
import 'angular-modal-service';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import BidFunnelModule from '../../common/bidFunnel/bidFunnel'
import StopReasonModal from './stopReasonModal';
import {getDateRanges, normalizeTimeframe, resetTimezone} from '../../common/datetime/date-ranges';
import template from './campaignsShow.jade';
import stopReasonModalTemplate from './stopReasonModal.jade';
import Format from '../../filters/format';

export class CampaignsShowController {
  /* @ngInject */
  constructor($stateParams,
              $state,
              $scope,
              $q,
              GamesResource,
              CampaignsResource,
              SegmentAnalyticsResource,
              Resource,
              $localStorage,
              $filter,
              ggTable,
              ModalService,
              stopReasonsOptions
  ) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$q = $q;
    this.ModalService = ModalService;
    this.stopReasonsOptions = stopReasonsOptions;
    this.GamesResource = GamesResource;
    this.CampaignsResource = CampaignsResource;
    this.SegmentAnalyticsResource = SegmentAnalyticsResource;
    this.Resource = Resource;
    this.$localStorage = $localStorage;
    this.translate = $filter('translate');
    this.format = $filter('format');
    this.apiDate = $filter('apiDate');
    this.apiDateMinusDays = $filter('apiDateMinusDays');
    this.query = new Rx.Subject();
    this.campaign = {
      id: $stateParams.id,
      game_id: $stateParams.gameId
    };
    this.isCampaignFetched = false;
    this.engagementOverviewShowAll = false;
    this.acquisitionOverviewShowAll = false;
    this.refresherCount = 0;

    this.availableSearchParams = [
      {key: "country", name: "Country", placeholder: "Country..."},
      {key: "platform", name: "Platform", placeholder: "Platform..."},
      {key: "acquisitionSource", name: "Acquisition Source", placeholder: "Acquisition Source..."},
      {key: "paying", name: "Paying", placeholder: "Paying..."}
    ];

    this.searchParams = {};

    this.timeframe = normalizeTimeframe(this.$localStorage.timeframe);
    this.timeframeForPreview = {
      startDate: getDateRanges().yesterday[0],
      endDate: getDateRanges().today[1]
    };

    this.segmentsBreakdownTable = new ggTable({count: 30});

    //// TODO remove $watch after ng-change="vm.updateQuery()" is integrated into searchbox component
    let vm = this;
    $scope.$watch('vm.searchParams', function (newValue) {
      if (newValue) {
        vm.getCampaignAnalytics();
      }
    }, true);

    if ($stateParams.id) {
      this.getCampaignAnalytics();
    } else {
      this.new = true;
    }
  }

  populateSeriesConfig(campaign_advertising_type) {
    this.breakdownSeries = {
      Acquisition: [
        {
          metric: 'clicks',
          format: 'number'
        },
        {
          metric: 'impressions',
          format: 'number'
        },
        {
          metric: 'ctr',
          format: 'percentage'
        },
        {
          metric: 'cpqi',
          format: (() => this.currency)
        },
        {
          metric: 'ecpqi',
          format: (() => this.currency)
        },
        {
          metric: 'ecpc',
          format: (() => this.currency)
        },
        {
          metric: 'ecpa',
          format: (() => this.currency)
        },
        {
          metric: 'leads',
          format: 'number'
        },
        {
          label: campaign_advertising_type === "UserAcquisition" ? this.translate('$analytics.acquisition.series.installs.label'): this.translate('$analytics.acquisition.series.app_open.label'),
          metric: 'app_open',
          format: 'number'
        },
        {
          label: campaign_advertising_type === "UserAcquisition" ? this.translate('$analytics.acquisition.series.installs_rate.label'): this.translate('$analytics.acquisition.series.app_open_rate.label'),
          metric: 'app_open_rate',
          format: 'percentage'
        }
      ],
      Engagement: [
        {
          metric: 'impressions',
          format: 'number'
        },
        {
          metric: 'clicks',
          format: 'number'
        },
        {
          label: campaign_advertising_type === "UserAcquisition" ? this.translate('$analytics.engagement.series.installs.label'): this.translate('$analytics.engagement.series.app_open.label'),
          metric: campaign_advertising_type === "UserAcquisition" ? 'installs' : 'app_open',
          format: 'number'
        },
        {
          label: campaign_advertising_type === "UserAcquisition" ? this.translate('$analytics.engagement.series.installs_rate.label'): this.translate('$analytics.engagement.series.app_open_rate.label'),
          metric: campaign_advertising_type === "UserAcquisition" ? 'installs_rate' : 'app_open_rate',
          format: 'percentage'
        },
        {
          metric: 'engaged_players',
          format: 'number'
        },
        {
          metric: 'cr',
          format: 'percentage'
        },
        {
          metric: 'ctr',
          format: 'percentage'
        },
        {
          metric: 'ecpm',
          format: (() => this.currency)
        },
        {
          metric: 'ecpc',
          format: (() => this.currency)
        },
        {
          metric: 'ecpi',
          label: campaign_advertising_type === "UserAcquisition" ? this.translate('$analytics.engagement.series.ecpi.label'): this.translate('$analytics.engagement.series.ecpo.label'),
          format: (() => this.currency)
        },
        {
          metric: 'ecpa',
          format: (() => this.currency)
        },
        {
          metric: 'cost',
          format: (() => this.currency)
        },
      ]
    };

    this.series = {
      engagement: [
        {
          metric: 'daily_targeted_players',
          type: 'spline',
          format: 'number'
        },
        {
          metric: 'engaged_players',
          type: 'spline',
          format: 'number'
        },
        {
          metric: 'conversion_rate',
          type: 'spline',
          yAxis: 1,
          format: 'percentage',
          serieCopy: {
            bigLabel: 'avg'
          }
        },
        {
          label: this.campaign.campaign_advertising_type === "UserAcquisition" ? 'Installs' : 'App Open',
          metric: 'app_open',
          type: 'spline',
          format: 'number'
        },
        {
          label: this.campaign.campaign_advertising_type === "UserAcquisition" ? 'Installs Rate' : 'App Open Rate',
          metric: 'app_open_rate',
          type: 'spline',
          yAxis: 1,
          format: 'percentage',
          serieCopy: {
            bigLabel: 'avg'
          }
        },
      ],
      performance: [
        {
          metric: 'clicks',
          type: 'spline',
          format: 'number'
        },
        {
          metric: 'impressions',
          type: 'spline',
          format: 'number'
        },
        {
          metric: 'ctr',
          type: 'spline',
          yAxis: 1,
          format: 'percentage',
          serieCopy: {
            bigLabel: 'avg'
          }
        }
      ],
      leads: [
        {
          metric: 'leads',
          type: 'spline',
          format: 'number',
          bigLabel: 'sum'
        }
      ],
      cost: {
        Acquisition: [
          {
            metric: 'cpqi',
            type: 'spline',
            format: (() => this.currency),
            decorateSerie: ((serie) => this.applyCampaignCostSerieMarkers(serie)),
            serieCopy: {
              bigLabel: 'sum'
            }
          },
          {
            metric: 'ecpqi',
            type: 'spline',
            decorateSerie: ((serie) => this.hideSerie(serie)),
            format: (() => this.currency)
          }
        ],
        Engagement: [
          {
            metric: 'cost',
            type: 'spline',
            format: (() => this.currency),
            decorateSerie: ((serie) => this.applyCampaignCostSerieMarkers(serie)),
            serieCopy: {
              bigLabel: 'sum'
            }
          },
          {
            metric: 'ecpm',
            type: 'spline',
            decorateSerie: ((serie) => this.hideSerie(serie)),
            format: (() => this.currency)
          },
          {
            metric: 'ecpc',
            type: 'spline',
            decorateSerie: ((serie) => this.hideSerie(serie)),
            format: (() => this.currency)
          },
          {
            metric: 'ecpe',
            type: 'spline',
            decorateSerie: ((serie) => this.hideSerie(serie)),
            format: (() => this.currency)
          },
          {
            metric: 'ecpi',
            label: campaign_advertising_type === "UserAcquisition" ? 'eCPI' : 'eCPO',
            type: 'spline',
            decorateSerie: ((serie) => this.hideSerie(serie)),
            format: (() => this.currency)
          },
        ]
      },
      topChannels: ['Engagement', 'Acquisition'].reduce((result, type) => {
        result[type] = _.filter(this.breakdownSeries[type], (serie) => (this.campaign.type !== 'EngagementCPC' && this.campaign.type !== 'EngagementCPA' && this.campaign.type !== 'EngagementCPI') || serie.metric !== 'ecpm')
          .map((serie) => {
            return _.assign({}, serie, {
              type: 'spline',
              queryParams: {breakdown_dimension: 'channel', top_n: 20},
              transformResponse: ((res) => this.topChannelsTransformResponse(res))
            });
          });
        return result;
      }, {}),
      topCreativeTypes: ['Engagement', 'Acquisition'].reduce((result, type) => {
        result[type] = _.filter(this.breakdownSeries[type], (serie) => (this.campaign.type !== 'EngagementCPC' && this.campaign.type !== 'EngagementCPA' && this.campaign.type !== 'EngagementCPI') || serie.metric !== 'ecpm')
            .map((serie) => {
              return _.assign({}, serie, {
                type: 'spline',
                queryParams: {breakdown_dimension: 'creative_type', top_n: 20},
                transformResponse: ((res) => this.topCreativeTypesTransformResponse(res))
              });
            });
        return result;
      }, {}),
      creativeSizePerformance: ['Engagement', 'Acquisition'].reduce((result, type) => {
        result[type] = _.filter(this.breakdownSeries[type], (serie) => (this.campaign.type !== 'EngagementCPC' && this.campaign.type !== 'EngagementCPA' && this.campaign.type !== 'EngagementCPI') || serie.metric !== 'ecpm')
          .map((serie) => {
          return _.assign({}, serie, {
            type: 'column',
            queryParams: {breakdown_dimension: 'creative_id', top_n: 900},
            getData: ((params) => {
              this.series.creativeSizePerformance.selectedMetric = params.metric;
              return this.Resource('campaign-analytics/creative-dimensions-breakdown', {baseUrl: '/api/v2'}).one().get(params)
                .then((res) => {
                  return this.creativeSizePerformanceTransformResponse(res, this.series.creativeSizePerformance.selectedMetric);
                })
            })
          });
        });
        return result;
      }, {}),
      creativeVariationPerformance: ['Engagement', 'Acquisition'].reduce((result, type) => {
        const filteredEcpiSerie = _.filter(this.breakdownSeries[type], (serie) => (this.campaign.campaign_advertising_type === "UserAcquisition" || serie.metric !== 'ecpi'));
        result[type] = _.filter(filteredEcpiSerie, (serie) => (this.campaign.type !== 'EngagementCPC' && this.campaign.type !== 'EngagementCPA' && this.campaign.type !== 'EngagementCPI') || serie.metric !== 'ecpm')
          .map((serie) => {
          return _.assign({}, serie, {
            type: 'column',
            queryParams: {breakdown_dimension: 'creative_id', top_n: 900},
            getData: ((params) => {
              this.series.creativeVariationPerformance.seriesMetric = params.metric;
              return this.Resource('campaign-analytics/variation-breakdown', {baseUrl: '/api/v2'}).one().get(params)
                .then((res) => {
                  return this.creativeVariationPerformanceTransformResponse(res, this.series.creativeVariationPerformance.seriesMetric);
                })
            })
          });
        });
        return result;
      }, {}),
      topCountries: ['Engagement', 'Acquisition'].reduce((result, type) => {
        result[type] = _.filter(this.breakdownSeries[type], (serie) => (this.campaign.type !== 'EngagementCPC' && this.campaign.type !== 'EngagementCPA' && this.campaign.type !== 'EngagementCPI') || serie.metric !== 'ecpm')
          .map((serie) => {
          return _.assign({}, serie, {
            type: 'pie',
            showInLegend: true,
            queryParams: {breakdown_dimension: 'country', top_n: 20},
            transformResponse: ((res, seriesName) => this.topValuesPieChartTransformResponse(res, seriesName))
          });
        });
        return result;
      }, {})
    };
  }

  refreshData() {
    this.updateFilterAndTimeframeDepententAnalytics(true);
  }

  updateCampaignAnalyticsQuery (doRefresh) {
    this.$localStorage.timeframe = this.timeframe;


    if (!this.campaign) {
      return;
    }

    let query = {
      campaign_id: this.campaign.id,
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate),
      countryCode: this.searchParams.countryCode,
      platform: this.searchParams.platform,
      acquisitionSource: this.searchParams.acquisitionSource,
      paying: this.searchParams.paying
    };

    if(doRefresh) {
      query.refresherCount = ++this.refresherCount;
    }

    this.query.onNext(query);
  }

  pauseCampaign() {
    if (this.campaign.status === 'paused') { return; }
    if (this.campaign.status === 'active') {
      this.promptStopReason().then(stopReason => {
        if (!stopReason) { return; }
        this.campaign.stop_reason = stopReason;
        this.applyPause();
      });
    } else {
      this.applyPause();
    }
  }

  promptStopReason() {
    return this.ModalService.showModal({
      template: stopReasonModalTemplate(),
      controllerAs: 'vm',
      controller: 'StopReasonModalController',
      inputs: {
        stopReasons: this.stopReasonsOptions
      }
    }).then(modal => modal.close);
  }

  applyPause() {
    this.campaign.start_mode = 'dont_start';
    this.campaign.end_mode = 'never';
    this.campaign.status = 'paused';
    this.campaign.save().then(() => {
      this.$state.go(this.$state.current, {}, {reload: true});
    });
  }

  cloneCampaign() {
    this.$state.go('app.campaigns.clone', {campaign: this.campaign.plain()});
  }

  calculateRemainingBudgetPercentage() {
    if (this.isBudgetCappingTypeClicks()) {
      this.campaign.remaining_budget_percent = 100 * (this.campaignAnalyticsOverview.clicks / this.campaign.budget_amount);
    } else if (this.isBudgetCappingTypeConversions()) {
      this.campaign.remaining_budget_percent = 100 * (this.campaignAnalyticsOverview.click_through_engagements / this.campaign.budget_amount);
    } else if (this.isBudgetCappingTypeInstalls()) {
      this.campaign.remaining_budget_percent = 100 * (this.campaignAnalyticsOverview.app_open / this.campaign.budget_amount);
    } else {
      this.campaign.remaining_budget_percent = 100 * (this.campaign.spent_budget_amount / this.campaign.budget_amount);
    }
  }

  calculateMonthlyRemainingBudgetPercentage() {
    this.campaign.monthly_remaining_budget_percent = 100 * (this.campaign.monthly_spent_budget_amount / this.campaign.monthly_budget_amount);
  }

  getCampaign() {
    return this.CampaignsResource.one(this.$stateParams.id).get()
      .then((res) => {
        this.campaign = this.resource = res;
        this.campaign.game_id = this.$stateParams.gameId;
        let startDate = moment(this.campaign.start_date);
        let endDate = moment(this.campaign.end_date);
        this.campaign.duration = endDate.diff(startDate, 'days');
        this.setAnalyticsResource(res.type);
        this.populateSeriesConfig(res.campaign_advertising_type);
      });
  }

  setAnalyticsResource(type) {
    if (type == 'Acquisition' || type == 'AcquisitionCPM' || type == 'BrandingCPM') {
      // Removed in PEP-4438
    } else {
      this.CampaignAnalyticsResource = this.Resource('campaign-analytics');
      this.CampaignAnalyticsBreakdownResource = this.Resource('campaign-analytics/breakdown', {baseUrl: '/api/v2'});
      this.CampaignAnalyticsCreativeDimensionsBreakdownResource = this.Resource('campaign-analytics/creative-dimensions-breakdown', {baseUrl: '/api/v2'});
      this.CampaignAnalyticsVariationBreakdownResource = this.Resource('campaign-analytics/variation-breakdown', {baseUrl: '/api/v2'});
    }
  }

  getCurrency() {
    this.currency = 'USD';
  }

  getCampaignAnalytics() {
    this.$localStorage.timeframe = this.timeframe;

    if (this.campaign.segment_ids) {
      this.updateAllAnalytics();
    } else {
      this.getCampaign().then(() => {
        this.updateAllAnalytics();
      })
    }
  }

  updateAllAnalytics() {
    this.updateFilterAndTimeframeDepententAnalytics();
    this.getCurrency();
    this.getSegmentsSizes();
    this.getAudienceSize();
    this.getSpentBudget();
    this.getMonthlySpentBudget();
  }

  updateFilterAndTimeframeDepententAnalytics(doRefresh) {
    this.getCampaignAnalyticsOverview();
    this.getCampaignAnalyticsOverviewBySegment();
    this.updateCampaignAnalyticsQuery(doRefresh);
    this.getBidFunnel();
  }

  getSegmentsSizes() {
    if (!this.campaign.segment_ids) {
      return;
    }

    let promises = [];
    let segmentsSizeSum = 0;

    angular.forEach(this.campaign.segment_ids, (segment_id) => {
      const promise = this.SegmentAnalyticsResource.one().get({
        segment_id,
        metric: 'size',
        start_date: this.apiDate(this.timeframeForPreview.startDate),
        end_date: this.apiDate(this.timeframeForPreview.endDate)
      });

      promises.push(promise);
    });

    this.$q.all(promises).then((responses) => {
      angular.forEach(responses, (response) => {
        let values = _.chain(response).get('data.rows', []).map('value').value();
        segmentsSizeSum += values[1] || values[0] || 0;
      });

      this.segmentSize = segmentsSizeSum;
    });

  }

  getAudienceSize() {
    if (!this.campaign.audience_id)
      return;

    this.Resource('audiences').one(this.campaign.audience_id).get().then((audience) => {
      this.Resource('audiences/size_preview').post(audience.plain()).then((res) => {
        this.audienceSize = res.size;
      });
    });
  }

  getBidFunnel () {
    const date = this.timeframe.endDate || this.timeframe.startDate;
    if (date) {
      this.bidFunnelDate = this.apiDateMinusDays(date, 1);
      this.Resource('campaign-analytics/bid-funnel-data').one().get({
        campaign_id: this.campaign.id,
        segment_ids: this.campaign.segment_ids,
        funnel_date: this.bidFunnelDate
      }).then((res) => {
        this.bidFunnelData = res.data;
      })
    }
  }

  buildOverviewQuery() {
    return {
      campaign_id: this.campaign.id,
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate),
      countryCode: this.searchParams.countryCode,
      platform: this.searchParams.platform,
      acquisitionSource: this.searchParams.acquisitionSource,
      paying: this.searchParams.paying
    };
  }

  getCampaignAnalyticsOverview() {
    this.CampaignAnalyticsResource.one('overview').get(
      this.buildOverviewQuery()
    ).then((res) => {
      this.campaignAnalyticsOverview = res.data;
    });
  }

  getCampaignAnalyticsOverviewBySegment() {
    this.CampaignAnalyticsResource.one('overview-by-segment').get(
      this.buildOverviewQuery()
    ).then((res) => {
      if (res.data && res.data.length > 1) {
        const sortedSegmentsData = _.sortBy(res.data, function(o) { return o.name; });
        this.segmentsBreakdownTable.loadData(sortedSegmentsData);
      }
    });
  }

  getSpentBudget() {
    this.CampaignAnalyticsResource.one().get({
      campaign_id: this.campaign.id,
      metric: this.campaign.type == 'Acquisition' ? 'cpqi' : 'cost',
      start_date: this.apiDate(resetTimezone(moment(new Date()).toDate())),
      end_date: this.apiDate(resetTimezone(moment(new Date()).toDate()))
    }).then(res => {
      this.campaign.spent_budget_amount = res.data.summary.sum || 0;
      this.calculateRemainingBudgetPercentage();
    });
  }

  getMonthlySpentBudget() {
    var firstDay = resetTimezone(moment(new Date()).startOf('month').hours(moment().hours()).toDate());
    var lastDay = resetTimezone(moment(new Date()).toDate());
    this.CampaignAnalyticsResource.one().get({
      campaign_id: this.campaign.id,
      metric: 'cost',
      start_date: this.apiDate(firstDay),
      end_date: this.apiDate(lastDay)
    }).then(res => {
      this.campaign.monthly_spent_budget_amount = res.data.summary.sum || 0;
      this.calculateMonthlyRemainingBudgetPercentage();
    });
  }

  getVariationInSeries(processedSeries, variationName) {
    return _.findIndex(processedSeries, (serie) => {
      return serie.data.key == variationName;
    });
  }

  getMetricIndexInSeries(processedSeries, metric) {
    return _.findIndex(processedSeries, (serie) => {
      return serie.data.key == metric;
    });
  }

  getNewSerie(series, metric) {
    let newSerie = _.cloneDeep(series[0] || {data: {}});
    newSerie.data.key = '';
    newSerie.data.rows = [];
    delete newSerie.data.summary;
    if(metric) {
      newSerie.query.metric = metric;
    }

    return newSerie;
  }

  getAggregateValue(series, aggregateKey) {
    let aggregateValue = 0;
    _.forEach(series, (serie) => {
      aggregateValue += serie.data.summary[aggregateKey];
    });
    if(aggregateKey == 'avg') aggregateValue /= series.length;

    return aggregateValue;
  }

  getAggregationType(metric) {
    switch(metric) {
      case 'ctr':
      case 'ecpc':
      case 'ecpa':
      case 'ecpm':
        return 'avg';
      default:
        return 'sum';
    }
  }

  formatValue(value, metric, seriesName) {
    if(seriesName) {
      let format = _.chain(_.get(this.series, seriesName)).filter({metric}).map('format').value()[0];
      if(_.isFunction(format)) {
        format = format();
      }
      return this.format(value, format);
    }
  }

  sortBreakdownSeries(series) {
    let aggregationType = this.getAggregationType(_.get(series, '[0].query.metric'));
    return _.sortBy(series, (serie) => { return -serie.data.summary[aggregationType]; })
  }

  topChannelsTransformResponse(series) {
    return this.sortBreakdownSeries(series);
  }

  topCreativeTypesTransformResponse(series) {
    return this.sortBreakdownSeries(series);
  }

  getVariationPerformanceRowIndexByVariationId(rows, variationId) {
    return _.findIndex(rows, (row) => {
      return row.id == variationId;
    });
  }

  creativeVariationPerformanceTransformResponse(APIresult) {
    let processedSeries = [];
    const filterEcpiForNonUserAcquisition = _.filter(this.breakdownSeries.Engagement, (serie) => (this.campaign.campaign_advertising_type === "UserAcquisition" || serie.metric !== 'ecpi'));
    _.forEach(filterEcpiForNonUserAcquisition, (metricObject) => {
      const emptyVariationSeriesObject = {
        data: {
          rows: [],
          key: ''
        },
        query: {}
      };

      processedSeries.push(_.cloneDeep(emptyVariationSeriesObject));
      processedSeries[processedSeries.length -1].data.key = metricObject.metric;

      _.forEach(APIresult.breakdown_data, (singleCreativeBreakdown) => {
        const rowIndex = this.getVariationPerformanceRowIndexByVariationId(processedSeries[processedSeries.length -1].data.rows, singleCreativeBreakdown.variation_id);
        if (rowIndex == -1) {
          processedSeries[processedSeries.length -1].data.rows.push({
            id: singleCreativeBreakdown.variation_id,
            key: singleCreativeBreakdown.variation_name,
            value: 0,
            tooltipTitle: metricObject.metric,
            tooltipValue: 0
          });
        }

        const actualRowIndex = rowIndex > -1 ? rowIndex : processedSeries[processedSeries.length -1].data.rows.length -1;

        processedSeries[processedSeries.length -1].data.rows[actualRowIndex].value += singleCreativeBreakdown[metricObject.metric];
        processedSeries[processedSeries.length -1].data.rows[actualRowIndex].tooltipValue += singleCreativeBreakdown[metricObject.metric];

      });
    });

    return processedSeries;
  }

  topValuesPieChartTransformResponse(series, seriesName) {
    let processedSeries = [];
    let metric = _.get(series[0],'query.metric');
    let translatedMetric = this.translate(`$analytics.campaign.${seriesName}.series.${metric}.label`);
    let aggregateValue;
    let formattedAggregateValue;
    let key;

    let newSerie = this.getNewSerie(series, metric);
    newSerie.data.key = translatedMetric;

    processedSeries.push(newSerie);

    _.forEach(series, (serie) => {
      aggregateValue = serie.data.summary[this.getAggregationType(metric)];
      if(aggregateValue > 0) {
        formattedAggregateValue = this.formatValue(aggregateValue, metric, `${seriesName}.${this.campaign.type}`);
        if(seriesName == 'topCountries') {
          key = this.translate(`countryCodes.${_.get(serie,'data.key')}`);
        }
        processedSeries[0].data.rows.push({
          key,
          value: aggregateValue,
          tooltipTitle: translatedMetric,
          tooltipValue: formattedAggregateValue
        });
      }
    });

    if(processedSeries[0].data.rows.length > 5) {
      processedSeries[0] = this.orderAndAggregateSmallValues(processedSeries[0], 5, metric, translatedMetric, seriesName);
    }

    return processedSeries;
  }

  orderAndAggregateSmallValues(serie, numberOfEntriesToNotAggregate, metric, translatedMetric, seriesName) {
    serie.data.rows = _.sortBy(serie.data.rows, (row) => { return -row.value; });

    let aggregationType = this.getAggregationType(metric);
    let pointsToAggregate = serie.data.rows.splice(numberOfEntriesToNotAggregate);
    let aggregateValue = 0;
    _.forEach(pointsToAggregate, (point) => {
      aggregateValue += point.value;
    });
    if(aggregationType == 'avg') aggregateValue /= pointsToAggregate.length;

    serie.data.rows.push({
      key: this.translate('others'),
      tooltipTitle: translatedMetric,
      tooltipValue: this.formatValue(aggregateValue, metric, `${seriesName}.${this.campaign.type}`),
      aggregateValuesInfo: pointsToAggregate,
      value: aggregateValue
    });

    return serie;
  }

  cleanCreativeSeriesResponse(series) {
    _.remove(series, (serie) => {
      return serie.data.key == '0';
    });
  }

  getSeriesIndexByVariationId(series, variationId) {
    return _.findIndex(series, (singleSeries) => {
      return _.find(singleSeries.data.rows, (row) => {
        return row.creative.variation_id == variationId;
      });
    });
  }

  creativeSizePerformanceTransformResponse(APIresult, selectedMetric) {
    // get all the creative sizes
    const creativeDimensions = _.chain(APIresult.breakdown_data).map('creative_dimensions').uniq().value();

    let processedSeries = [];
    const emptyVariationSeriesObject = {
      data: {
        rows: [],
        key: '',
        name: ''
      },
      query: {}
    };

    _.forEach(APIresult.breakdown_data, (singleCreativeBreakdown) => {
        const variationSeriesIndex = this.getSeriesIndexByVariationId(processedSeries, singleCreativeBreakdown.variation_id);
        if(variationSeriesIndex == -1) {
          // create a series for this variation
          processedSeries.push(_.cloneDeep(emptyVariationSeriesObject));
          const currentJustAddedSerie = processedSeries[processedSeries.length -1];

          currentJustAddedSerie.data.key = '' + singleCreativeBreakdown.variation_name;

          // add a placeholder point foreach creative dimension
          _.forEach(creativeDimensions, (creativeDimensions) => {
            currentJustAddedSerie.data.rows.push({
              name: creativeDimensions,
              key: creativeDimensions,
              value: null,
              creative: {
                variation_id: singleCreativeBreakdown.variation_id,
                size: creativeDimensions,
                variationName: singleCreativeBreakdown.variation_name,
              }
            });
          })
        }

        const rowsOfCurrentSeries = processedSeries[variationSeriesIndex > -1 ? variationSeriesIndex: processedSeries.length -1].data.rows;
        // find the row with the matching creative dimension and add infos from singleCreativeBreakdown
        let indexOfPointForThisCreativeDimension = _.findIndex(rowsOfCurrentSeries, {key: singleCreativeBreakdown.creative_dimensions});
        if (indexOfPointForThisCreativeDimension > -1) {
          rowsOfCurrentSeries[indexOfPointForThisCreativeDimension] = {
            name: singleCreativeBreakdown.creative_dimensions,
            key: singleCreativeBreakdown.creative_dimensions,
            value: singleCreativeBreakdown[selectedMetric],
            creative: {
              id: singleCreativeBreakdown.creative_id,
              variation_id: singleCreativeBreakdown.variation_id,
              active: singleCreativeBreakdown.creative_active,
              size: singleCreativeBreakdown.creative_dimensions,
              url: singleCreativeBreakdown.creative_url,
              variationName: singleCreativeBreakdown.variation_name,
            }
          };
        }
    });

    return processedSeries;
  }

  hideSerie(serie) {
    serie.visible = false;
    return serie;
  }

  applyCampaignCostSerieMarkers(serie) {
    return this.CampaignsResource.one(this.campaign.id)
      .getList('status-history',{
        campaign_id: this.campaign.id,
        start_date: this.apiDate(this.timeframe.startDate),
        end_date: this.apiDate(this.timeframe.endDate)
      })
      .then(res => {
        res.plain()
          .filter(r => r.new_status == 'paused_due_to_budget')
          .forEach(r => {
            let row = _.find(serie.data, ({key}) => moment.utc(key).diff(moment.utc(r.entry_time), 'days') == 0);
            if (row) {
              row.marker = {
                radius: 5,
                symbol: 'circle',
                fillColor: '#f97163',
                tooltipText: this.translate('paused_due_to_budget')
              };
            }
          });
      });
  }

  isEngagementCampaign() {
    return this.campaign.type == 'Engagement' || this.campaign.type == 'EngagementCPC' || this.campaign.type == 'EngagementCPA' || this.campaign.type == 'EngagementCPI';
  }

  isBudgetCappingTypeMonetary() {
    return this.campaign.budget_capping_type == 'Monetary';
  }

  isBudgetCappingTypeClicks() {
    return this.campaign.type == 'EngagementCPC' && this.campaign.budget_capping_type == 'Event';
  }

  isBudgetCappingTypeConversions() {
    return this.campaign.type == 'EngagementCPA' && this.campaign.budget_capping_type == 'Event';
  }

  isBudgetCappingTypeInstalls() {
    return this.campaign.type == 'EngagementCPI' && this.campaign.budget_capping_type == 'Event';
  }

  isBudgetCappingTypeUnlimited() {
    return this.campaign.budget_capping_type == 'Unlimited';
  }

  isMonthlyBudgetCappingTypeUnlimited() {
    return this.campaign.monthly_budget_capping_type == 'Unlimited';
  }
}

export function CampaignsShowComponent() {
  return {
    template,
    controller: CampaignsShowController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.campaigns.show', [
  'angularModalService',
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name,
  BidFunnelModule.name,
  StopReasonModal.name,
  Format.name
])
.directive('campaignsShow', CampaignsShowComponent);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/campaignsShow.js
 **/